/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-11-23 15:36:58
 * @LastEditors: Jack Deng
 * @LastEditTime: 2022-06-22 12:27:40
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorText/Item/index.tsx
 */
import { ItemWrapper } from '@/src/components';
import { Input, Select } from '@/src/components/Antd';
import { SectionContainer } from '@/src/components/Layouts';
import { Icon } from '@/src/tools/icon';
import { get } from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import Slider from 'src/components/Slider/MarginSlider';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import FontStyleSetting from '../../Components/FontStyleSetting';
import { onChangeField } from '../slice';
import { fontList, genericFamilyOption } from '../tool';
import styles from './style.less';
function Item(props: any) {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const _d = useDispatch();
  const { theme = {}, type, errorProcessingProps, isOnPrimaryLanguage } = props;
  const { specificError } = errorProcessingProps;
  // const currentLanguage = useSelector(currentSelectedLanguage());
  return (
    <SectionContainer className={styles.container}>
      <ItemWrapper title={'Button Text Font'}>
        <Select
          size={'large'}
          value={get(theme, 'textFont')}
          // options={currentLanguage === 'zh-CN' ? genericFamilyOption : fontList}
          options={[...fontList, ...genericFamilyOption]}
          onChange={(v) =>
            _d(onChangeField({ type, prop: 'textFont', value: v }))
          }
        />
      </ItemWrapper>
      <ItemWrapper title={'Font Size'}>
        <div className={styles.flex}>
          <Input
            error={
              specificError['fontSize'] &&
              specificError['fontSize']?.length !== 0
            }
            help={specificError['fontSize']}
            size={'large'}
            suffix={'px'}
            value={theme?.fontSize}
            onChange={(value) =>
              _d(onChangeField({ type, prop: 'fontSize', value }))
            }
          />
          <FontStyleSetting
            value={{
              bold: theme?.bold,
              underline: theme?.underline,
              italic: theme?.italic,
            }}
            onChange={(value) => {
              _d(
                onChangeField({
                  type,
                  prop: ['bold', 'italic', 'underline'],
                  value,
                }),
              );
            }}
          />
        </div>
      </ItemWrapper>
      <Slider
        title={'Line Height'}
        customIcon={
          <Icon
            type={'icona-lineheight'}
            className={styles.icon}
            style={{ fontSize: 18 }}
          />
        }
        max={100}
        min={1}
        value={theme?.lineHeight}
        onChange={(v) =>
          _d(onChangeField({ type, prop: 'lineHeight', value: v }))
        }
      />
      {isOnPrimaryLanguage && (
        <ItemWrapper title={getI18n('general.textColour')}>
          <ColorPicker
            multi
            color={theme?.textColor}
            onChange={(color) =>
              _d(onChangeField({ type, prop: 'textColor', value: color }))
            }
          />
        </ItemWrapper>
      )}
    </SectionContainer>
  );
}

export default Item;
